<template>
  <v-layout>
    <v-col class="custom-content-container pt-0" cols="12" :md="12" :sm="12">
      <v-layout class="d-block customer-create-new-customer">
        <v-row>
          <v-col class="iv-custom-field" cols="9" md="9" sm="9">
            <perfect-scrollbar :options="{ suppressScrollX: true }" class="scroll"
              style="max-height: 90vh; position: relative">


              <v-container fluid>

                <div style="background-color: #e8f4ff; padding: 8px;margin-bottom:10px;" v-if="!customer?.id">
                  <strong style="font-size: 18px;font-weight: 700 !important;">Contact Details</strong>
                </div>

                <v-row v-if="lodash.isEmpty(customer)" class="mb-2">
                  <v-col lg="3" class="my-auto py-0">
                    <label class="font-size-16 font-weight-500" for="company_type">Customer Type
                    </label>
                  </v-col>
                  <v-col lg="8" class="my-auto py-0">
                    <v-radio-group v-model="detail.company_type" row hide-details class="mt-0" v-on:change="resetData">
                      <v-radio style="margin-right: -2px" value="company" color="blue"></v-radio>
                      <v-chip label color="blue" outlined class="text-white p-3 mr-5" small>Company</v-chip>
                      <v-radio value="personal" color="red" style="margin-right: -2px"></v-radio>
                      <v-chip label color="red" outlined class="text-white p-3" small>Individual</v-chip>
                    </v-radio-group>
                  </v-col>
                </v-row>
                <v-row v-if="lodash.isEmpty(customer)" class="mb-2">
                  <v-col class="pt-0" md="3" sm="12">
                    <label class="font-size-16 font-weight-500" for="company_type">Primary Contact</label>
                  </v-col>
                  <v-col class="pt-0" md="3" sm="12">
                    <!--  <label class="font-size-16 font-weight-500" for="salutation"
                      >Salutation</label
                    > -->
                    <v-select id="salutation" v-model.trim="detail.salutation" :items="salutationList" dense filled
                      item-text="text" item-value="value" item-color="cyan" placeholder="Salutation" solo flat
                      color="cyan"></v-select>
                  </v-col>
                  <v-col class="pt-0" md="3" sm="12">
                    <!-- <label
                      class="font-size-16 font-weight-500 required"
                      for="first_name"
                      >First Name</label
                    > -->

                    <v-text-field id="first_name" v-model.trim="detail.first_name" :rules="[
                      validateRules.required(detail.first_name, 'first name'),
                      validateRules.minLength(
                        detail.first_name,
                        'first name',
                        2
                      ),
                      validateRules.maxLength(
                        detail.first_name,
                        'first name',
                        100
                      ),
                    ]" dense filled placeholder="First Name" solo flat color="cyan" class="required-field"
                      v-on:keyup="appendDisplayName()"></v-text-field>
                  </v-col>
                  <v-col class="pt-0" md="3" sm="12">
                    <!-- <label class="font-size-16 font-weight-500" for="last_name"
                      >Last Name</label
                    > -->
                    <v-text-field id="last_name" v-model.trim="detail.last_name" :rules="[
                      validateRules.minLength(
                        detail.last_name,
                        'last name',
                        2
                      ),
                      validateRules.maxLength(
                        detail.last_name,
                        'last name',
                        100
                      ),
                    ]" dense filled placeholder="Last Name" solo flat color="cyan"
                      v-on:keyup="appendDisplayName()"></v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="false">
                  <v-col md="12" sm="12">
                    <v-switch v-model.trim="detail.primary" class="mt-0" inset color="cyan"
                      placeholder="Use company name as the display name"></v-switch>
                  </v-col>
                </v-row>
                <v-row class="mb-2" v-if="detail.company_type == 'company'">
                  <v-col md="3" sm="12">
                    <label class="font-size-16 font-weight-500 mt-4" for="company_name"
                      :class="{ required: detail.primary }">Company Name</label>
                  </v-col>
                  <v-col md="9" sm="12">
                    <TextValidateInput :disabled="pageLoading" :loading="pageLoading" :rules="company_rules()"
                      id="company-name" placeholder="Company Name" :validationField="{
                        url_type: 'customer',
                        filter_type: 'contact',
                        field: 'company_name',
                      }" :parent-id="detail.id" :current-id="detail.id" show-dropdown v-model="detail.company_name">
                    </TextValidateInput>
                  </v-col>

                  <v-col v-if="false" md="6" sm="12">
                    <label class="font-size-16 font-weight-500 required" for="entity-id">Entity</label>
                    <v-select id="entity-id" v-model.trim="detail.entity_id" :items="entityList" dense filled :rules="[
                      validateRules.required(detail.entity_id, 'entity'),
                    ]" item-text="name" item-value="id" item-color="cyan" placeholder="Entity" solo flat
                      color="cyan"></v-select>
                  </v-col>
                  <!--  <v-col md="6" sm="12">
                    <label
                      class="font-size-16 font-weight-500 required"
                      for="group_id"
                      >Group</label
                    >
                    <v-select
                      id="group_id"
                      v-model.trim="detail.group_id"
                      :items="groupList"
                      dense
                      filled
                      :rules="[
                        validateRules.required(detail.group_id, 'group'),
                      ]"
                      item-text="text"
                      item-value="id"
                      item-color="cyan"
                      placeholder="Group"
                      solo
                      flat
                      color="cyan"
                    ></v-select>
                  </v-col>
                  <v-col v-if="false" md="4" sm="12">
                    <PhoneTextField
                      id="t-phone"
                      v-model="detail.phone"
                      :value="detail.phone"
                      required
                    >
                    </PhoneTextField>
                  </v-col>
                  <v-col md="6" sm="12">
                    <label class="font-size-16 font-weight-500" for="website"
                      >Website</label
                    >
                    <v-text-field
                      id="website"
                      v-model.trim="detail.website"
                      :rules="[
                        validateRules.minLength(detail.website, 'website', 3),
                        validateRules.maxLength(detail.website, 'website', 50),
                      ]"
                      dense
                      filled
                      placeholder="Website"
                      solo
                      flat
                      color="cyan"
                      class="required-field"
                    ></v-text-field>
                  </v-col>
                  <v-col v-if="false" md="6" sm="12">
                    <label
                      class="font-size-16 font-weight-500 required"
                      for="security_code"
                      >Security Code</label
                    >
                    <v-text-field
                      id="security_code"
                      v-model.trim="detail.security_code"
                      :rules="[
                        validateRules.required(
                          detail.security_code,
                          'security code'
                        ),
                        validateRules.minLength(
                          detail.security_code,
                          'security code',
                          3
                        ),
                        validateRules.maxLength(
                          detail.security_code,
                          'security code',
                          50
                        ),
                      ]"
                      dense
                      filled
                      placeholder="Security Code"
                      solo
                      flat
                      color="cyan"
                      class="required-field"
                    ></v-text-field>
                  </v-col>
                  <v-col md="6" sm="12">
                    <label
                      class="font-size-16 font-weight-500"
                      for="company_name"
                      >UEN</label
                    >
                    <v-text-field
                      id="uen"
                      v-model.trim="detail.uen"
                      dense
                      filled
                      placeholder="UEN"
                      solo
                      flat
                      color="cyan"
                    ></v-text-field>
                  </v-col> -->

                  <template v-if="false">
                    <v-col md="4" sm="12">
                      <v-hover v-slot="{ hover }">
                        <div class="custom-google-autocomplete">
                          <v-text-field append-icon="search" :loading="autocompleteLoading"
                            v-on:keyup="getGoogleAddress" v-on:blur="isFocused = false" v-on:focus="isFocused = true"
                            v-model.trim="detail.postal_code" :rules="[
                              validateRules.required(
                                detail.postal_code,
                                'postal code'
                              ),
                              validateRules.minLength(
                                detail.postal_code,
                                'postal code',
                                6
                              ),
                              validateRules.maxLength(
                                detail.postal_code,
                                'postal code',
                                6
                              ),
                            ]" dense filled placeholder="Postal Code" solo flat v-mask="'######'" color="cyan"
                            class="required-field">
                          </v-text-field>
                          <v-list v-if="
                            (hover || isFocused) && autocompleteList.length
                          " two-line elevation="4" class="custom-google-autocomplete-list">
                            <v-list-item v-for="(address, index) in autocompleteList" :key="index" link
                              v-on:click="selectGoogleAddress(index)">
                              <v-list-item-icon class="m-0 mr-3 my-auto">
                                <v-icon color="cyan"> mdi-map-marker </v-icon>
                              </v-list-item-icon>
                              <v-list-item-content class="py-1" v-if="
                                lodash.isEmpty(
                                  address.structured_formatting
                                ) === false
                              ">
                                <v-list-item-title class="font-size-14">{{
                                  address.structured_formatting.main_text
                                }}</v-list-item-title>
                                <v-list-item-subtitle class="font-size-12">{{
                                  address.structured_formatting.secondary_text
                                }}</v-list-item-subtitle>
                              </v-list-item-content>
                              <v-list-item-content class="py-1" v-else>
                                <v-list-item-title class="font-size-14">{{
                                  address.description
                                }}</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </div>
                      </v-hover>
                    </v-col>
                    <v-col md="4" sm="12">
                      <v-text-field v-model.trim="detail.unit_number" :rules="[
                        validateRules.minLength(
                          detail.unit_number,
                          'unit no',
                          1
                        ),
                        validateRules.maxLength(
                          detail.unit_number,
                          'unit no',
                          100
                        ),
                      ]" dense filled placeholder="Unit No." solo flat color="cyan"
                        class="required-field"></v-text-field>
                    </v-col>
                    <v-col md="4" sm="12">
                      <v-text-field v-model.trim="detail.address_line_1" :rules="[
                        validateRules.minLength(
                          detail.address_line_1,
                          'address line 1',
                          3
                        ),
                        validateRules.maxLength(
                          detail.address_line_1,
                          'address line 1',
                          50
                        ),
                      ]" dense filled placeholder="Address Line 1" solo flat color="cyan"
                        class="required-field"></v-text-field>
                    </v-col>
                    <v-col md="4" sm="12">
                      <v-text-field v-model.trim="detail.address_line_2" :rules="[
                        validateRules.minLength(
                          detail.address_line_2,
                          'address line 2',
                          3
                        ),
                        validateRules.maxLength(
                          detail.address_line_2,
                          'address line 2',
                          50
                        ),
                      ]" dense filled placeholder="Address Line 2" solo flat color="cyan"
                        class="required-field"></v-text-field>
                    </v-col>
                  </template>
                </v-row>
                <v-row v-if="detail.company_type == 'company'" class="mb-2">
                  <v-col class="pt-0" md="3" sm="12">
                    <label class="font-size-16 font-weight-500 required mt-4" for="display_name">Display Name</label>
                  </v-col>
                  <v-col class="pt-0" md="4" sm="12">
                    <!--  <label class="font-size-16 font-weight-500" for="salutation"
                        >Salutation</label
                      > -->
                    <TextValidateInput :disabled="pageLoading" :loading="pageLoading" :rules="[
                      validateRules.required(
                        detail.display_name,
                        'Display Name'
                      ),
                    ]" id="display-name" placeholder="Display Name" :validationField="{
                      url_type: 'customer',
                      filter_type: 'contact',
                      field: 'display_name',
                    }" :parent-id="detail.id" :current-id="detail.id" show-dropdown v-model="detail.display_name">
                    </TextValidateInput>
                  </v-col>
                  <v-col class="pt-0 text-right" md="1" sm="12">
                    <label class="font-size-16 font-weight-500 mt-4" for="uen">UEN</label>
                  </v-col>
                  <v-col class="pt-0" md="4" sm="12">
                    <TextValidateInput :disabled="pageLoading" :loading="pageLoading"
                      :rules="[validateRules.minLength(detail.uen, 'UEN', 3)]" id="display-name" placeholder="UEN"
                      :validationField="{
                        url_type: 'customer',
                        filter_type: 'contact',
                        field: 'uen',
                      }" :parent-id="detail.id" :current-id="detail.id" show-dropdown v-model="detail.uen">
                    </TextValidateInput>
                  </v-col>
                </v-row>
                <v-row v-if="detail.company_type == 'personal'" class="mb-2">
                  <v-col class="pt-0 mt-4" md="3" sm="12">
                    <label class="font-size-16 font-weight-500 required" for="display_name">Display Name</label>
                  </v-col>
                  <v-col class="pt-0" md="9" sm="12">
                    <!--  <label class="font-size-16 font-weight-500" for="salutation"
                        >Salutation</label
                      > -->
                    <TextValidateInput :disabled="pageLoading" :loading="pageLoading" :rules="[
                      validateRules.required(
                        detail.display_name,
                        'display name'
                      ),
                      validateRules.minLength(
                        detail.display_name,
                        'display name',
                        2
                      ),
                      validateRules.maxLength(
                        detail.display_name,
                        'display name',
                        100
                      ),
                    ]" id="display-name" placeholder="Display Name" :validationField="{
                      url_type: 'customer',
                      filter_type: 'contact_person',
                      field: 'display_name',
                    }" :parent-id="detail.id" :current-id="detail.id" show-dropdown v-model="detail.display_name">
                    </TextValidateInput>
                  </v-col>
                </v-row>

                <v-row v-if="detail.company_type == 'personal'" class="mb-2">
                  <v-col class="pt-0 mt-1" md="3" sm="12">
                    <label class="font-size-16 font-weight-500" for="display_name">Email Address</label>
                  </v-col>
                  <v-col class="pt-0" md="9" sm="12">
                    <!--  <label class="font-size-16 font-weight-500" for="salutation"
                        >Salutation</label
                      > -->
                    <v-text-field v-model.trim="detail.person_email" :rules="[
                      validateRules.validEmail(detail.person_email, 'email'),
                      validateRules.minLength(
                        detail.person_email,
                        'email',
                        2
                      ),
                      validateRules.maxLength(
                        detail.person_email,
                        'email',
                        100
                      ),
                    ]" dense filled placeholder="Email" solo flat color="cyan" class="required-field"></v-text-field>
                    <!--    <template v-if="isFocusedU">
                      <div
                        class="suggested-content elevation-2"
                        v-if="suggestedItems6 && suggestedItems6.length"
                      >
                        <template v-for="(item, index) in suggestedItems6">
                          <v-list-item :key="index" class="py-2">
                            <v-list-item-content>
                              <v-list-item-title
                                v-text="item.person_email"
                              ></v-list-item-title>
                            </v-list-item-content>
                            <span class="red--text px-3 pt-1"
                              >Already exists
                            </span>
                          </v-list-item>
                          <v-divider
                            class="my-0"
                            :key="`index--${index}`"
                          ></v-divider>
                        </template>
                      </div>
                    </template> -->
                  </v-col>
                </v-row>

                <v-row v-if="detail.company_type == 'personal'" class="mb-2">
                  <v-col class="pt-0" md="3" sm="12">
                    <label class="font-size-16 font-weight-500" for="display_name">Mobile Number</label>
                  </v-col>
                  <v-col class="pt-0" md="9" sm="12">
                    <!--  <label class="font-size-16 font-weight-500" for="salutation"
                        >Salutation</label
                      > -->
                    <PhoneTextField v-model="detail.mobile_number" placeholder="Mobile Number">
                    </PhoneTextField>
                  </v-col>
                </v-row>
                <v-row v-if="detail.company_type == 'personal'" class="mb-2">
                  <v-col class="pt-0" md="3" sm="12">
                    <label class="font-size-16 font-weight-500" for="display_name">Landline Number</label>
                  </v-col>
                  <v-col class="pt-0" md="9" sm="12">
                    <!--  <label class="font-size-16 font-weight-500" for="salutation"
                        >Salutation</label
                      > -->
                    <PhoneTextField v-model="detail.landline_number" placeholder="Landline Number">
                    </PhoneTextField>
                  </v-col>
                  <v-col class="pt-0" md="3" sm="12">
                    <label class="font-size-16 font-weight-500" for="display_name">Dialysis Shift</label>
                  </v-col>

                  <v-col class="pt-0" md="9" sm="12">
                    <v-autocomplete hide-details v-model.trim="detail.dialysis_shift" :items="dialysisShiftList" dense
                      flat filled placeholder="Dialysis Shift" item-color="cyan" color="cyan" solo item-value="value"
                      item-text="label">
                      <template v-slot:no-data>
                        <v-list-item>
                          <v-list-item-title v-html="'No Shift(s) Found.'"></v-list-item-title>
                        </v-list-item>
                      </template>
                      <template v-slot:selection="{ item }">
                        <v-list-item-content class="py-0">
                          <v-list-item-title class="text-capitalize font-weight-500 font-size-16">
                            <template>{{ item.label }} </template>
                          </v-list-item-title>
                        </v-list-item-content>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row v-if="detail.company_type == 'company'" class="mb-2">
                  <v-col class="pt-0" md="3" sm="12">
                    <label class="font-size-16 font-weight-500" for="display_name">Company Email Address</label>
                  </v-col>
                  <v-col class="pt-0" md="4" sm="12">
                    <!--  <label class="font-size-16 font-weight-500" for="salutation"
                            >Salutation</label
                          > -->
                    <v-text-field v-model.trim="detail.company_email" :rules="[
                      // validateRules.required(detail.company_email, 'email'),
                      validateRules.validEmail(detail.company_email, 'email'),
                      validateRules.minLength(
                        detail.company_email,
                        'email',
                        2
                      ),
                      validateRules.maxLength(
                        detail.company_email,
                        'email',
                        100
                      ),
                    ]" dense filled placeholder="Email" solo flat color="cyan" v-on:blur="isFocusedU = false"
                      v-on:focus="isFocusedU = true"></v-text-field>
                    <!--  v-on:keyup="
                        getCustomerListEmail(
                          detail.company_email,
                          'company_email'
                        )
                      "-->

                    <template v-if="isFocusedU">
                      <div class="suggested-content elevation-2" v-if="suggestedItems5 && suggestedItems5.length">
                        <template v-for="(item, index) in suggestedItems5">
                          <v-list-item :key="index" class="py-2">
                            <v-list-item-content>
                              <v-list-item-title v-text="item.company_email"></v-list-item-title>
                            </v-list-item-content>
                            <span class="red--text px-3 pt-1">Already exists
                            </span>
                          </v-list-item>
                          <v-divider class="my-0" :key="`index--${index}`"></v-divider>
                        </template>
                      </div>
                    </template>
                  </v-col>
                  <v-col class="pt-0 text-right" md="1" sm="12">
                    <label class="font-size-16 font-weight-500" for="website">Website</label>
                  </v-col>
                  <v-col class="pt-0" md="4" sm="12">
                    <v-text-field id="website" v-model.trim="detail.website" :rules="[
                      v => !detail.website || validateRules.minLength(detail.website, 'website', 3),
                      v => !detail.website || validateRules.maxLength(detail.website, 'website', 50),
                    ]" dense filled placeholder="Website" solo flat color="cyan" class="required-field"></v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="detail.company_type == 'company'" class="mb-2">
                  <v-col class="pt-0" md="3" sm="12">
                    <label class="font-size-16 font-weight-500" for="display_name">Company phone number</label>
                  </v-col>
                  <v-col class="pt-0" md="4" sm="12">
                    <PhoneTextField v-model="detail.company_number" v-on:blur="isFocusedN = false"
                      v-on:focus="isFocusedN = true">
                    </PhoneTextField>
                    <!--v-on:change="
                        getCustomerListMobile(
                          detail.company_number,
                          'company_number'
                        )
                      "-->
                  </v-col>
                  <template v-if="isFocusedN">
                    <div class="suggested-content elevation-2" v-if="suggestedItems4 && suggestedItems4.length">
                      <template v-for="(item, index) in suggestedItems4">
                        <v-list-item :key="index" class="py-2">
                          <v-list-item-content>
                            <v-list-item-title v-text="item.company_number"></v-list-item-title>
                          </v-list-item-content>
                          <span class="red--text px-3 pt-1">Already exists
                          </span>
                        </v-list-item>
                        <v-divider class="my-0" :key="`index--${index}`"></v-divider>
                      </template>
                    </div>
                  </template>
                  <v-col class="pt-0 text-right" md="1" sm="12">
                    <label class="font-size-16 font-weight-500" for="website">Company fax</label>
                  </v-col>
                  <v-col class="pt-0" md="4" sm="12">
                    <PhoneTextField v-model="detail.company_fax" placeholder="Company fax">
                    </PhoneTextField>
                  </v-col>
                </v-row>
                <v-row class="mb-2" v-if="detail.company_type == 'company'">
                  <v-col class="pt-0" md="3" sm="12">
                    <label class="font-size-16 font-weight-500" for="sales_person">Sales Person
                    </label>
                  </v-col>
                  <v-col class="pt-0" md="4" sm="12">
                    <!-- <TextField
                      id="sales-person"
                      dense
                      filled
                      placeholder="Sales Person"
                      solo
                      flat
                      counter="50"
                      v-model="detail.sales_person"
                      color="cyan"
                      :maxlength="250"
                    /> -->
                    <v-autocomplete hide-details v-model.trim="detail.sales_person_id" :items="userList" dense flat
                      filled placeholder="Sales Person" item-color="cyan" color="cyan" solo item-value="id"
                      item-text="display_name">
                      <template v-slot:no-data>
                        <v-list-item>
                          <v-list-item-title v-html="'No Assign to(s) Found.'"></v-list-item-title>
                        </v-list-item>
                      </template>
                      <template v-slot:selection="{ item }">
                        <v-list-item-content class="py-0">
                          <v-list-item-title class="text-capitalize font-weight-500 font-size-16">
                            <template v-if="item.id == 'all'">{{ item.display_name }}
                            </template>
                            <template v-else>{{ item.display_name }} </template>
                          </v-list-item-title>
                        </v-list-item-content>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col class="pt-0 text-right" md="1" sm="12">
                    <label class="font-size-16 font-weight-500" for="website">Sales Contact</label>
                  </v-col>
                  <v-col class="pt-0" md="4" sm="12">
                    <PhoneTextField v-model="detail.sales_contact" placeholder="Sales Contact">
                    </PhoneTextField>
                  </v-col>
                </v-row>



                <v-row class="mb-2 mt-2">

                  <v-col class="pt-0" md="3" sm="12" v-if="customer?.id">
                    <label class="font-size-16 font-weight-500" for="payment_method">Payment Method</label>
                  </v-col>
                  <v-col class="pt-0" md="4" sm="12" v-if="customer?.id">
                    <TagAutoComplete type="customer" v-model="detail.payment_method" />
                  </v-col>
                </v-row>



                <v-row>
                  <template v-if="detail.company_type == 'company'">
                    <v-col class="pt-0" md="3" sm="12">
                      <label class="font-size-16 font-weight-500" for="display_name">Dialysis Shift</label>
                    </v-col>

                    <v-col class="pt-0" md="4" sm="12">
                      <v-autocomplete hide-details v-model.trim="detail.dialysis_shift" :items="dialysisShiftList" dense
                        flat filled placeholder="Dialysis Shift" item-color="cyan" color="cyan" solo item-value="value"
                        item-text="label">
                        <template v-slot:no-data>
                          <v-list-item>
                            <v-list-item-title v-html="'No Shift(s) Found.'"></v-list-item-title>
                          </v-list-item>
                        </template>
                        <template v-slot:selection="{ item }">
                          <v-list-item-content class="py-0">
                            <v-list-item-title class="text-capitalize font-weight-500 font-size-16">
                              <template>{{ item.label }} </template>
                            </v-list-item-title>
                          </v-list-item-content>
                        </template>
                      </v-autocomplete>
                    </v-col>
                  </template>
                  <template v-if="detail.company_type == 'company'">
                    <v-col class="pt-0" md="1" sm="12">
                      <label class="font-size-16 font-weight-500" for="display_name">Customer Remark</label>
                    </v-col>

                    <v-col class="pt-0" md="4" sm="12">
                      <v-textarea v-model="detail.customer_remark" auto-grow dense filled color="cyan"
                        placeholder="Customer Remark" solo flat row-height="15" v-on:keypress="(e) => manageLimit(e)"
                        v-on:paste="(e) => onPaste(e)"></v-textarea>
                      <v-col md="12" class="text-right">{{
                        detail.customer_remark
                          ? detail.customer_remark.length
                          : 0
                      }}/200</v-col>
                    </v-col>
                  </template>
                </v-row>

                <v-row class="mb-2">
                  <v-col lg="12" class="d-flex">
                    <label>Requires Special Attention? </label>
                    <v-switch class="ml-4" color="cyan" dense inset hide-details v-model="detail.special_attention"
                      :true-value="1" :false-value="0">
                    </v-switch>
                  </v-col>
                </v-row>

                <v-row class="mb-2" v-if="!customer?.id">
                  <v-col lg="12" class="d-flex">
                    <label>Any funding organisation ? </label>
                    <v-switch class="ml-4" color="cyan" dense inset hide-details
                      v-model="detail.is_funding_organisation" :true-value="1" :false-value="0">
                    </v-switch>
                  </v-col>
                </v-row>


                <div style="background-color: #e8f4ff; padding: 8px;margin-bottom:15px;"
                  v-if="!customer?.id && detail.is_funding_organisation">
                  <strong style="font-size: 18px;font-weight: 700 !important;">Funding Details</strong>
                </div>

                <v-row class="mb-2">
                  <v-col class="pt-0" md="3" sm="12" v-if="!customer?.id && detail.is_funding_organisation">
                    <label class="font-size-16 font-weight-500 required" for="funding_organization">Funding
                      Organisation</label>
                  </v-col>
                  <v-col class="pt-0" md="4" sm="12" v-if="!customer?.id && detail.is_funding_organisation">

                    <v-autocomplete :items="fundingOrganisations" dense. filled color="cyan" item-color="cyan" solo flat
                      v-model.trim="detail.funding_group_id" placeholder="Select Funding Organisation" item-text="text"
                      item-value="id" class="width-100 new-height" hide-details :rules="[
                        validateRules.required(
                          detail.funding_group_id,
                          'Funding Organisation'
                        ),
                      ]">
                      <template v-slot:no-data>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-title v-html="'No Funding Organisation(s) Found.'"></v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                  </v-col>

                  <v-col class="pt-0 text-right" md="1" sm="12" v-if="!customer?.id && detail.is_funding_organisation">
                    <label class="font-size-16 font-weight-500" for="payment_method">Payment Method</label>
                  </v-col>
                  <v-col class="pt-0" md="4" sm="12" v-if="!customer?.id && detail.is_funding_organisation">
                    <TagAutoComplete type="customer" v-model="detail.payment_method" />
                  </v-col>
                </v-row>

                <v-row v-if="customer.id || detail.is_funding_organisation">
                  <v-col class="pt-0" md="3" sm="12">
                    <label class="font-size-16 font-weight-500" for="service">Service</label>
                  </v-col>
                  <v-col class="pt-0" md="4" sm="12">

                    <v-autocomplete :items="serviceList" dense. filled color="cyan" item-color="cyan" solo flat
                      v-model.trim="detail.service" append-outer-icon="mdi-cog" placeholder="Select Service"
                      v-on:click:append-outer="ServiceData" item-text="text" item-value="value"
                      class="width-100 new-height" hide-details>
                      <template v-slot:no-data>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-title v-html="'No Service(s) Found.'"></v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                  </v-col>

                  <!-- <v-col class="pt-0 px-0" md="1" sm="12" v-if="customer?.id">
                    <label
                      class="font-size-16 font-weight-500 text-right"
                      for="actual_start_date"
                      >Actual Start Date</label
                    >
                  </v-col>
                  <v-col class="pt-0 mt-0" md="4" sm="12" v-if="customer?.id">
                   
                     <DatePicker
                          solo
                          flat
                          :mandatory="false"
                          :nullable="true"
                          placeholder="Actual Start Date"
                          :min-date ="detail.contract_start_date"
                          :max-date="detail.contract_end_date"
                          v-model="detail.actual_start_date"
                       ></DatePicker>
                  </v-col> -->


                  <v-col class="pt-0 text-right" md="1" sm="12">
                    <label class="font-size-16 font-weight-500" for="payment_type">
                      Payment Type
                    </label>
                  </v-col>
                  <v-col class="pt-0" md="4" sm="12">

                    <v-autocomplete :items="paymentTypeList" dense. filled color="cyan" item-color="cyan" solo flat
                      v-model.trim="detail.payment_type" append-outer-icon="mdi-cog" placeholder="Payment Type"
                      v-on:click:append-outer="openPaymentTypeDialog" item-text="text" item-value="value"
                      class="width-100 new-height" hide-details>
                      <template v-slot:no-data>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-title v-html="'No Payment type(s) Found.'"></v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                  </v-col>

                </v-row>

                <v-row v-if="!customer?.id && detail.is_funding_organisation">
                  <v-col class="pt-0" md="12" sm="12">
                    <strong style="font-size: 16px;font-weight: 700 !important;">Contract Details</strong>
                  </v-col>

                </v-row>

                <v-row class="mb-3 mt-2">
                  <v-col class="pt-0" md="3" sm="12" v-if="!customer?.id && detail.is_funding_organisation">
                    <label class="font-size-16 font-weight-500" for="contract_type">Contract Type</label>
                  </v-col>
                  <v-col class="pt-0" md="4" sm="12" v-if="!customer?.id && detail.is_funding_organisation">

                    <v-text-field dense filled color="cyan" solo flat hide-details :disabled="pageLoading"
                      :loading="pageLoading" id="contract-type" placeholder="Contract Type"
                      v-model="detail.contract_type"></v-text-field>

                  </v-col>

                  <v-col class="pt-0 text-right" md="1" sm="12" v-if="!customer?.id && detail.is_funding_organisation">
                    <label class="font-size-16 font-weight-500" for="contract_duration">Contract Duration</label>
                  </v-col>


                  <v-col class="pt-0" md="4" sm="12" v-if="!customer?.id && detail.is_funding_organisation">

                    <v-text-field dense filled color="cyan" solo flat hide-details :disabled="pageLoading"
                      :loading="pageLoading" id="contract-duration" placeholder="Contract Duration"
                      v-model="detail.contract_duration"></v-text-field>

                  </v-col>


                </v-row>


                <v-row class="mb-3" v-if="!customer?.id && detail.is_funding_organisation">
                  <v-col class="pt-0" md="3" sm="12">
                    <label class="font-size-16 font-weight-500 required" for="contract_start_date">Contract Start
                      Date</label>
                  </v-col>
                  <v-col class="pt-0 mt-0" md="4" sm="12">

                    <DatePicker solo flat :mandatory="false" :nullable="true" placeholder="Contract Start Date"
                      v-model="detail.contract_start_date" :rules="[
                        validateRules.required(
                          detail.contract_start_date,
                          'Contract Start Date'
                        ),
                      ]"></DatePicker>
                  </v-col>

                  <v-col class="pt-0 text-right" md="1" sm="12">
                    <label class="font-size-16 font-weight-500 required" for="contract_end_date">Contract End
                      Date</label>
                  </v-col>

                  <v-col class="pt-0" md="4" sm="12">

                    <DatePicker solo flat :mandatory="false" :nullable="true" placeholder="Contract End Date"
                      v-model="detail.contract_end_date" :min-date="detail.contract_start_date" :rules="[
                        validateRules.required(
                          detail.contract_end_date,
                          'Contract End Date'
                        ),
                      ]"></DatePicker>
                  </v-col>


                </v-row>

                <v-row class="mb-3" v-if="!customer?.id && detail.is_funding_organisation">
                  <!-- <v-col class="pt-0" md="3" sm="12">
                    <label
                      class="font-size-16 font-weight-500"
                      for="contract_status"
                      >Contract Status</label
                    >
                  </v-col> -->
                  <!-- <v-col class="pt-0 mt-0" md="4" sm="12">
                   
                     <v-autocomplete
                    :items="contractStatuses"
                    dense.
                    filled
                    color="cyan"
                    item-color="cyan"
                    solo
                    flat
                    v-model.trim="detail.contract_status"
                    append-outer-icon="mdi-cog"
                    placeholder="Contract Status"
                    v-on:click:append-outer="contractStatus"
                    item-text="text"
                    item-value="value"
                    class="width-100 new-height"
                    hide-details
                  
                  >
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title
                            v-html="'No Contract Status(s) Found.'"
                          ></v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                  </v-col> -->

                  <v-col class="pt-0" md="3" sm="12" v-if="!customer?.id">
                    <label class="font-size-16 font-weight-500 text-right" for="actual_start_date">Actual Start
                      Date</label>
                  </v-col>
                  <v-col class="pt-0 mt-0" md="4" sm="12">

                    <DatePicker solo flat :mandatory="false" :nullable="true" placeholder="Actual Start Date"
                      v-model="detail.actual_start_date" :min-date="detail.contract_start_date"
                      :max-date="detail.contract_end_date">
                    </DatePicker>
                  </v-col>

                  <v-col class="pt-0" md="1" sm="12" v-if="!customer?.id">
                    <label class="font-size-16 font-weight-500 text-right required" for="actual_start_date">Copayment
                      Amount</label>
                  </v-col>
                  <v-col class="pt-0 mt-0" md="4" sm="12">


                    <div class="d-flex" style="gap: 0; margin: 0; padding: 0;">

                      <v-select style="flex: 0 0 15%;" :items="copaymentTypeList" v-model="detail.copayment_amount_type"
                        hide-details item-text="type" item-value="value" item-color="cyan"
                        class="line-item-header-text discount-type text-h6 px-0" placeholder="Type" dense filled solo
                        flat color="cyan" />

                      <v-text-field style="flex: 0 0 85%;" dense color="cyan" filled type="number"
                        v-on:keypress="limitDecimal($event, detail.copayment_amount)" v-model="detail.copayment_amount"
                        v-model.trim.number.lazy="detail.copayment_amount" :rules="[
                          validateRules.required(
                            detail.copayment_amount,
                            'Contract End Date'
                          ),
                        ]" placeholder="Copayment Amount" solo flat hide-details
                        @input="validateCopaymentAmount(detail)">
                      </v-text-field>

                    </div>

                  </v-col>


                </v-row>


                <!--   <template v-for="(cdata, index) in contactDetails">
                    <v-row class="contact-detail-row" :key="'contact-' + index">
                      <v-col md="3">
                        <template v-if="cdata.title == 'main'">
                          <label
                              class="font-size-16 font-weight-500 required"
                              >Company phone number</label
                            >
                        </template>
                        <template v-if="cdata.title == 'fax'">
                          <label
                              class="font-size-16 font-weight-500"
                              >Company fax</label
                            >
                        </template>
                    
                      </v-col>
                      <v-col md="7">
                      
                        <PhoneTextField
                          :id="`contact-${index}`"
                          v-model="cdata.value"
                          :value="cdata.value"
                          :required="cdata.title == 'main'"
                        >
                        </PhoneTextField>
                      </v-col>
                      <v-col md="2" v-if="false">
                        <template v-if="index > 0">
                          <v-btn
                            class="mx-2 mt-6"
                            color="red lighten-1"
                            dark
                            fab
                            small
                            v-on:click="removeContactDetail(index)"
                          >
                            <v-icon dark> mdi-trash-can-outline</v-icon>
                          </v-btn>
                        </template>
                        <template v-else>
                          <v-btn
                            class="mx-2 mt-6"
                            color="cyan"
                            dark
                            fab
                            small
                            v-on:click="pushContactDetail"
                          >
                            <v-icon dark> mdi-plus</v-icon>
                          </v-btn>
                        </template>
                      </v-col>
                    </v-row>
                  </template> -->
                <template>
                  <!--  <template v-for="(cdata, index) in emailDetails">
                    <v-row class="contact-detail-row" :key="'email-' + index">
                      <v-col md="3">
                        <label
                          class="font-size-16 font-weight-500 required"
                          :for="`email-type-${index}`"
                          >Type</label
                        >
                        <v-select
                          :id="`email-type-${index}`"
                          v-model.trim="cdata.title"
                          :items="emailTypeList"
                          :rules="[validateRules.required(cdata.title, 'type')]"
                          dense
                          filled
                          item-text="text"
                          item-value="value"
                          item-color="cyan"
                          placeholder="Type"
                          solo
                          flat
                          color="cyan"
                        ></v-select>
                      </v-col>
                      <v-col md="7">
                        <label
                          class="font-size-16 font-weight-500 required"
                          :for="`email-${index}`"
                          >Email</label
                        >
                        <v-text-field
                          :id="`email-${index}`"
                          v-model.trim="cdata.value"
                          :rules="[
                            validateRules.required(cdata.value, 'email'),
                            validateRules.validEmail(cdata.value, 'email'),
                            validateRules.minLength(cdata.value, 'email', 2),
                            validateRules.maxLength(cdata.value, 'email', 100),
                          ]"
                          dense
                          filled
                          placeholder="Email"
                          solo
                          flat
                          color="cyan"
                          class="required-field"
                        ></v-text-field>
                      </v-col>
                      <v-col md="2" v-if="false">
                        <template v-if="index > 0">
                          <v-btn
                            class="mx-2 mt-30"
                            color="red lighten-1"
                            dark
                            fab
                            small
                            v-on:click="removeEmailDetail(index, cdata)"
                          >
                            <v-icon dark> mdi-trash-can-outline</v-icon>
                          </v-btn>
                        </template>
<template v-else>
                          <v-btn
                            class="mx-2 mt-30"
                            color="cyan"
                            dark
                            fab
                            small
                            v-on:click="pushEmailDetail"
                          >
                            <v-icon dark> mdi-plus</v-icon>
                          </v-btn>
                        </template>
</v-col>
</v-row>
</template>
<template v-for="(cdata, index) in contactDetails">
                    <v-row class="contact-detail-row" :key="'contact-' + index">
                      <v-col md="3">
                        <label
                          :class="`font-size-16 font-weight-500 ${
                            cdata.title == 'main' ? 'required' : ''
                          }`"
                          :for="`contact-type-${index}`"
                          >Type</label
                        >
                        <v-select
                          :id="`contact-type-${index}`"
                          v-model.trim="cdata.title"
                          :items="contactTypeList"
                          :rules="[validateRules.required(cdata.title, 'type')]"
                          dense
                          filled
                          item-text="text"
                          item-value="value"
                          item-color="cyan"
                          placeholder="Type"
                          solo
                          flat
                          color="cyan"
                          readonly
                        ></v-select>
                      </v-col>
                      <v-col md="7">
                        <label
                          :class="`font-size-16 font-weight-500 ${
                            cdata.title == 'main' ? 'required' : ''
                          }`"
                          :for="`contact-${index}`"
                          >Phone Number</label
                        >
                        <PhoneTextField
                          :id="`contact-${index}`"
                          v-model="cdata.value"
                          :value="cdata.value"
                          :required="cdata.title == 'main'"
                        >
                        </PhoneTextField>
                      </v-col>
                      <v-col md="2" v-if="false">
                        <template v-if="index > 0">
                          <v-btn
                            class="mx-2 mt-6"
                            color="red lighten-1"
                            dark
                            fab
                            small
                            v-on:click="removeContactDetail(index)"
                          >
                            <v-icon dark> mdi-trash-can-outline</v-icon>
                          </v-btn>
                        </template>
<template v-else>
                          <v-btn
                            class="mx-2 mt-6"
                            color="cyan"
                            dark
                            fab
                            small
                            v-on:click="pushContactDetail"
                          >
                            <v-icon dark> mdi-plus</v-icon>
                          </v-btn>
                        </template>
</v-col>
</v-row>
</template> -->
                </template>
              </v-container>
            </perfect-scrollbar>
          </v-col>
          <v-col class="iv-custom-field" cols="3" md="3" sm="3" v-on:mouseleave="imageTemplate = false"
            v-on:mouseover="imageTemplate = true">
            <template>
              <v-img :lazy-src="$defaultProfileImage" :src="getProfileImage" max-height="200" max-width="200"
                height="200px" width="200px"
                class="custom-grey-border custom-border-radius-50 company-image-logo margin-auto">
              </v-img>
              <div class="margin-auto">
                <v-btn class="my-4 custom-bold-button width-100" outlined small v-on:click="selectImage" color="cyan"
                  :loading="imageLoading" :disabled="imageLoading">
                  <template v-if="getProfileImage">Change Image</template>
                  <template v-else>Upload Image</template>
                </v-btn>
                <div class="d-none">
                  <v-file-input ref="uploadImage" v-on:change="updateProfileImage" :rules="imageRules"
                    accept="image/png, image/jpeg, image/jpg"></v-file-input>
                </div>
              </div>
            </template>
          </v-col>
        </v-row>
        <!--    <v-row>
            <v-col md="12" sm="12">
              <h3>Contact Details</h3>
              <ContactPersons
                
                  ></ContactPersons>
            </v-col>
        </v-row> -->
      </v-layout>
    </v-col>
    <template v-if="false && !isDialog">
      <v-col class="custom-sidebar-container grey lighten-3" cols="12" md="3" sm="3">
        <template v-for="(fieldInfo, indx) in fieldDescriptions">
          <div v-if="fieldInfo.field == currentActiveField" :key="indx" class="help-sidebar">
            <div class="help-sidebar-header">
              <h3 v-if="fieldInfo.title" class="section-header-title">
                {{ fieldInfo.title }}
              </h3>
            </div>
            <p v-if="fieldInfo.description" class="help-sidebar-description">
              {{ fieldInfo.description }}
            </p>
            <h5 v-if="fieldInfo.footer" class="help-sidebar-footer-title">
              {{ fieldInfo.footer }}
            </h5>
            <p v-if="fieldInfo.footer_content" class="help-sidebar-footer-text">
              {{ fieldInfo.footer_content }}
            </p>
          </div>
        </template>
      </v-col>
    </template>
    <template>
      <ManageOrganisation :d-dialog="manageOrganisationDialog" :e_funding_organisation="fundingOrganisations"
        v-on:close-dialog="manageOrganisationDialog = false" v-on:get-e-funding-organisation="getOptions">
      </ManageOrganisation>
    </template>

    <template>

    </template>

    <template>
      <ManageService :d-dialog="manageService" :e_services="serviceList" v-on:close-dialog="manageService = false"
        v-on:get-e-services="getOptions"></ManageService>

      <ManagePaymentCategory :d-dialog="managePaymentType" :e_payment_categories="paymentTypeList"
        v-on:close-dialog="managePaymentType = false" v-on:get-e-payment-categories="getOptions">
      </ManagePaymentCategory>

    </template>

  </v-layout>
</template>

<script>
import ManageOrganisation from "@/view/pages/partials/Manage-Organisation.vue";
import ManageService from "@/view/pages/partials/Manage-Service.vue";
import ManagePaymentCategory from "@/view/pages/partials/Manage-Payment-Category.vue";
import CommonMixin from "@/core/plugins/common-mixin";
import ValidationMixin from "@/core/plugins/validation-mixin";
import CustomerMixin from "@/core/plugins/customer-mixin";
import { GET, QUERY, DELETE } from "@/core/services/store/request.module";
import FileManagerMixin from "@/core/lib/file-manager/file.manager.mixin";
import PhoneTextField from "@/view/pages/partials/PhoneTextField";
import { getConfig } from "@/core/services/local.service";
import TextValidateInput from "@/view/pages/partials/TextValidateInput.vue";
import DatePicker from "@/view/components/DatePicker.vue";
import TagAutoComplete from "@/view/pages/partials/TagAutoCompleteInput";


/* import ContactPersons from "@/view/pages/customer/create-or-update/Contact-Persons.vue"; */
export default {
  name: "contact-details",
  title: "Customer",
  mixins: [CommonMixin, ValidationMixin, CustomerMixin, FileManagerMixin],
  props: {
    customer: {
      type: Object,
      default: function () {
        return {};
      },
    },
    lead: {
      type: Object,
      default: function () {
        return {};
      },
    },
    isDialog: {
      type: Boolean,
      default: false,
    },

  },
  data() {
    return {
      copaymentTypeList: [
        { type: "$", value: 1 },
        { type: "%", value: 2 },
      ],
      dialysisShiftList: [
        {
          label: "135AM",
          value: "135AM",
        },
        {
          label: "135NN",
          value: "135NN",
        },
        {
          label: "135PM",
          value: "135PM",
        },
        {
          label: "246AM",
          value: "246AM",
        },
        {
          label: "246NN",
          value: "246NN",
        },
        {
          label: "246PM",
          value: "246PM",
        },
        {
          label: "15AM",
          value: "15AM",
        },
        {
          label: "15NN",
          value: "15NN",
        },
        {
          label: "15PM",
          value: "15PM",
        },
        {
          label: "26AM",
          value: "26AM",
        },
        {
          label: "26NN",
          value: "26NN",
        },
        {
          label: "26PM",
          value: "26PM",
        },
      ],
      manageOrganisationDialog: false,
      manageContractStatus: false,
      managePaymentType: false,
      manageService: false,
      fundingOrganisations: [],
      contractStatuses: [],
      serviceList: [],
      paymentTypeList: [],
      groupList: [],
      pageLoading: false,
      entityList: [],
      proposal: 0,
      timeoutLimit: 500,
      timeout: null,
      autocompleteList: new Array(),
      suggestedItems: [],
      suggestedItems2: [],
      suggestedItems3: [],
      suggestedItems4: [],
      suggestedItems5: [],
      suggestedItems6: [],
      autocompleteLoading: false,
      isFocused: false,
      isFocusedU: false,
      isFocusedN: false,
      isFocusedD: false,
      userList: [],
      detail: {
        sales_person_id: 0,
        primary: true,
        company_email: null,
        company_number: null,
        company_fax: null,
        person_email: null,
        landline_number: null,
        mobile_number: null,
        salutation: "mr",
        customer_remark: null,
        first_name: null,
        last_name: null,
        company_type: "company",
        company_name: null,
        uen: null,
        display_name: null,
        profile_logo: null,
        entity_id: 1,
        group_id: 1,
        phone: null,
        website: null,
        security_code: null,
        unit_number: null,
        address_line_1: null,
        address_line_2: null,
        postal_code: null,
        country: null,
        state: null,
        city: null,
        details: [],
        sales_person: null,
        sales_contact: null,
        is_funding_organisation: 0,
        special_attention: 0,
        funding_group_id: null,
        payment_method: [],
        contract_type: null,
        contract_duration: null,
        contract_start_date: null,
        contract_end_date: null,
        service: null,
        actual_start_date: null,
        payment_type: null,
        copayment_amount_type: 1,
        copayment_amount: null
      },
      imageLoading: false,
      emailDetails: [
        {
          title: "main",
          value: null,
          type: 1,
          id: null,
        },
      ],
      contactDetails: [
        {
          title: "main",
          value: null,
          type: 2,
          id: null,
        },
        {
          title: "fax",
          value: null,
          type: 2,
          id: null,
        },
      ],
      imageTemplate: false,
      fieldDescriptions: [
        {
          field: "product_type",
          title: "Product Type",
          description:
            "Select if this item is a physical good or a service you're offering.",
          footer: "Note",
          footer_content:
            "Once you include this items in a transaction, you cannot change its type.",
        },
      ],
    };
  },
  watch: {

    "detail.primary"() {
      if (this.detail.primary) {
        this.detail.display_name = this.detail.company_name;
      }
    },

    'detail.copayment_amount_type'() {

      this.detail.copayment_amount = null;
    },


    "detail.company_name"() {
      if (this.detail.primary) {
        // this.detail.display_name =
        //   this.detail.company_type == "company"
        //     ? (this.detail.display_name?this.detail.display_name:this.detail.company_name)
        //     : this.detail.display_name;
        if (this.customer.id > 0) {
          this.detail.company_type == "company"
            ? this.detail.display_name
            : this.detail.company_name;
        } else {
          this.detail.display_name =
            this.detail.company_type == "company"
              ? this.detail.company_name
              : this.detail.display_name;
        }
      }
    },
    detail: {
      deep: true,
      immediate: true,
      handler(param) {
        this.$emit("saveContactDetail", param);
      },
    },
    lead: {
      deep: true,
      immediate: true,
      handler() {
        this.getLead();
      },
    },
    emailDetails: {
      deep: true,
      handler() {
        this.updateDetails();
      },
    },
    contactDetails: {
      deep: true,
      handler() {
        this.updateDetails();
      },
    },
    isDialog: {
      deep: true,
      immediate: true,
      handler(param) {
        if (param) {
          this.getOptions();
        }
      },
    },
  },
  methods: {


    validateCopaymentAmount(detail) {
      this.$nextTick(() => {
        let amount = parseFloat(detail.copayment_amount) || 0;

        if (detail.copayment_amount_type === 2 && amount >= 100) {

          detail.copayment_amount = 100.00;

        }
      });

    },

    OrganisationData() {
      this.manageOrganisationDialog = true;
      this.getOptions();
    },

    ServiceData() {
      this.manageService = true;
      this.getOptions();
    },

    openPaymentTypeDialog() {

      this.managePaymentType = true;
      this.getOptions();

    },




    contractStatus() {
      this.manageContractStatus = true;
      this.getOptions();
    },


    getOptions() {
      const _this = this;
      _this.$store
        .dispatch(GET, { url: "customer/options" })
        .then(({ data }) => {
          _this.options = data.options;
          _this.userList = data.users;
          _this.fundingOrganisations = data.funding_organisations;
          _this.serviceList = data.services;
          _this.paymentTypeList = data.payment_types;

        })
        .catch((error) => {
          _this.logError(error);
        });
      /*.finally(() => {
          _this.$refs.customerForm.validate();
        });*/
    },
    resetData() {
      (this.detail.salutation = "mr"),
        (this.detail.first_name = null),
        (this.detail.last_name = null),
        (this.detail.company_name = null),
        (this.detail.uen = null),
        (this.detail.display_name = null);
      this.detail.company_email = null;
      this.detail.website = null;
      this.detail.company_number = null;
      this.detail.company_fax = null;
      this.detail.customer_remark = null;
    },

    company_rules() {
      const rules = [];

      if (this.detail.primary) {
        rules.push(
          this.validateRules.required(this.detail.company_name, "display name")
        );
      }

      rules.push(
        this.validateRules.minLength(
          this.detail.company_name,
          "display name",
          2
        )
      );

      rules.push(
        this.validateRules.maxLength(
          this.detail.company_name,
          "display name",
          100
        )
      );

      return rules;
    },
    appendDisplayName() {
      const result = [];
      const { first_name, last_name } = this.detail;
      if (first_name) {
        result.push(first_name);
      }
      if (last_name) {
        result.push(last_name);
      }
      /* if (!this.detail.primary) {
        console.log(this.detail.primary) */
      if (this.detail.company_type == "personal") {
        this.detail.display_name = result.join(" ");
      }

      /*    } */
    },
    clearAddress() {
      const _this = this;
      _this.detail.postal_code = null;
      _this.detail.address_line_1 = null;
      _this.detail.address_line_2 = null;
      _this.detail.unit_number = null;
    },
    /*  manageLimit(e) {
      if (
        this.detail.customer_remark &&
        this.detail.customer_remark.length > 199
      ) {
        e.preventDefault();
      }
    }, */

    onPaste(e) {
      let coppied = e.clipboardData.getData("Text");
      let preVal = this.detail.customer_remark;
      let finalval = String(preVal) + String(coppied);
      if (Number(finalval.length) > 199) {
        let trimValue = finalval.substring(0, 200);
        this.detail.customer_remark = trimValue;
        e.preventDefault();
      }
    },

    manageLimit(e) {
      if (
        this.detail.customer_remark &&
        this.detail.customer_remark.length > 199
      ) {
        e.preventDefault();
      }
    },

    selectGoogleAddress(index) {
      const _this = this;
      if (_this.lodash.isEmpty(_this.autocompleteList[index]) === false) {
        let place_id = _this.autocompleteList[index].place_id;
        _this.autocompleteLoading = true;
        _this.$store
          .dispatch(QUERY, {
            url: "google-api/place-detail",
            data: { "place-id": place_id },
          })
          .then((response) => {
            _this.formatAddress(response.data);
          })
          .catch((error) => {
            _this.logError(error);
          })
          .finally(() => {
            _this.clearAddress();
            _this.autocompleteList = new Array();
            _this.autocompleteLoading = false;
          });
      }
    },
    /* getExistingData(search_key,name) {
      this.suggestedItems = [];
      if (search_key) {
        let requestParams = {
          type: 'customers',
          name: name,
          value: search_key,
        };
        this.getCustomerList(requestParams);
      }
    }, */
    getCustomerList(search_key) {
      this.suggestedItems = [];
      const _this = this;
      _this.$store
        .dispatch(QUERY, {
          url: "search-company",
          data: {
            type: "customers",
            name: "company_name",
            value: search_key ? search_key : "null",
          },
        })
        .then((data) => {
          this.suggestedItems = data;
        })
        .catch((error) => {
          _this.logError(error);
        });
    },
    getCustomerListDisplay(search_key) {
      this.suggestedItems2 = [];
      const _this = this;
      _this.$store
        .dispatch(QUERY, {
          url: "search-company",
          data: {
            type: "customers",
            name: "display_name",
            value: search_key ? search_key : "null",
          },
        })
        .then((data) => {
          this.suggestedItems2 = data;
        })
        .catch((error) => {
          _this.logError(error);
        });
    },
    getCustomerListEmail(search_key) {
      this.suggestedItems5 = [];
      const _this = this;
      _this.$store
        .dispatch(QUERY, {
          url: "search-customer",
          data: {
            type: "company",
            name: "company_email",
            value: search_key ? search_key : "null",
          },
        })
        .then((data) => {
          this.suggestedItems5 = data;
        })
        .catch((error) => {
          _this.logError(error);
        });
    },
    getCustomerEmail(search_key) {
      this.suggestedItems6 = [];
      const _this = this;
      _this.$store
        .dispatch(QUERY, {
          url: "search-customer",
          data: {
            type: "individual",
            name: "primary_email",
            value: search_key ? search_key : "null",
          },
        })
        .then((data) => {
          this.suggestedItems6 = data;
        })
        .catch((error) => {
          _this.logError(error);
        });
    },

    getCustomerListMobile(search_key) {
      this.suggestedItems4 = [];
      const _this = this;
      _this.$store
        .dispatch(QUERY, {
          url: "search-customer",
          data: {
            type: "company",
            name: "company_number",
            value: search_key ? search_key : "null",
          },
        })
        .then((data) => {
          this.suggestedItems4 = data;
        })
        .catch((error) => {
          _this.logError(error);
        });
    },
    getCustomerListUen(search_key) {
      this.suggestedItems3 = [];
      const _this = this;
      _this.$store
        .dispatch(QUERY, {
          url: "search-company",
          data: {
            type: "customers",
            name: "uen",
            value: search_key ? search_key : "null",
          },
        })
        .then((data) => {
          this.suggestedItems3 = data;
        })
        .catch((error) => {
          _this.logError(error);
        });
    },
    formatAddress(param) {
      const _this = this;
      try {
        _this.autocompleteLoading = true;
        _this
          .formatGPSAddress(param)
          .then((result) => {
            if (_this.lodash.isEmpty(param) === false) {
              _this.detail.postal_code = result.zip_code;
              _this.detail.address_line_1 = result.street_1;
              _this.detail.address_line_2 = result.street_2;
              _this.detail.unit_number = result.unit_no;
            }
          })
          .catch((error) => {
            _this.logError(error);
          })
          .finally(() => {
            _this.autocompleteLoading = false;
          });
      } catch (error) {
        _this.logError(error);
      }
    },
    getGoogleAddress() {
      const _this = this;
      try {
        if (_this.detail.postal_code && _this.detail.postal_code.length == 6) {
          _this.autocompleteLoading = true;
          clearTimeout(_this.timeout);
          _this.autocompleteList = new Array();
          _this.timeout = setTimeout(function () {
            _this.$store
              .dispatch(QUERY, {
                url: "google-api/autocomplete",
                data: { search: _this.detail.postal_code },
              })
              .then((response) => {
                _this.autocompleteList = response.data;
              })
              .catch((error) => {
                _this.logError(error);
              })
              .finally(() => {
                _this.autocompleteLoading = false;
              });
          }, _this.timeoutLimit);
        } else {
          _this.autocompleteList = new Array();
        }
      } catch (error) {
        _this.logError(error);
      }
    },
    selectImage() {
      this.$refs["uploadImage"].$refs["input"].click();
    },
    updateDetails() {
      const _this = this;
      _this.detail.details = [];
      for (let i = 0; i < _this.emailDetails.length; i++) {
        if (_this.emailDetails[i]) {
          delete _this.emailDetails[i].default;
          _this.detail.details.push(_this.emailDetails[i]);
        }
      }
      for (let z = 0; z < _this.contactDetails.length; z++) {
        if (_this.contactDetails[z]) {
          delete _this.contactDetails[z].default;
          _this.detail.details.push(_this.contactDetails[z]);
        }
      }
    },
    pushEmailDetail() {
      this.emailDetails.push({
        title: "main",
        value: null,
        type: 1,
        id: null,
      });
    },
    removeEmailDetail(index, row) {
      if (row && row.id) {
        this.$store
          .dispatch(DELETE, {
            url: `customer/${row.customer}/detail`,
            data: { details: [row.id] },
          })
          .then(() => {
            this.emailDetails.splice(index, 1);
          })
          .catch((error) => {
            this.logError(error);
          });
      } else {
        this.emailDetails.splice(index, 1);
      }
    },
    pushContactDetail() {
      this.contactDetails.push({
        title: "main",
        value: null,
        type: 2,
        id: null,
      });
    },
    removeContactDetail(index) {
      this.contactDetails.splice(index, 1);
    },
    updateProfileImage(param) {
      const _this = this;
      _this.imageLoading = true;
      _this
        .uploadAttachment(param)
        .then((response) => {
          _this.detail.profile_logo = _this.lodash.head(response);
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.imageLoading = false;
        });
    },

    getGroupList() {
      const _this = this;
      _this.$store
        .dispatch(GET, {
          url: "customer/group-list",
        })
        .then(({ data }) => {
          _this.groupList = data.group_list;
          if (_this.lodash.isEmpty(_this.customer) === true) {
            _this.detail.security_code = data.security_code;
          }
        })
        .catch((error) => {
          _this.logError(error);
        });
    },
    editDetails() {

      const _this = this;

      _this.defaultPerson = _this.getDefaultPerson(_this.customer);
      _this.emailDetails = _this.getEmailDetails(_this.customer);
      _this.contactDetails = _this.getPhoneDetails(_this.customer);

      const faxContactDetails = _this.lodash.filter(_this.contactDetails, {
        title: "fax",
      });

      const mainContactDetails = _this.lodash.filter(_this.contactDetails, {
        title: "main",
      });

      if (_this.lodash.isEmpty(mainContactDetails)) {
        _this.contactDetails.push({
          title: "main",
          value: null,
          type: 2,
          id: null,
        });
      }

      if (_this.lodash.isEmpty(faxContactDetails)) {
        _this.contactDetails.push({
          title: "fax",
          value: null,
          type: 2,
          id: null,
        });
      }

      _this.detail.salutation = _this.defaultPerson.title;
      _this.detail.first_name = _this.defaultPerson.first_name;
      _this.detail.last_name = _this.defaultPerson.last_name;

      _this.detail.primary = _this.customer.primary;

      _this.detail.company_name = _this.customer.company_name;
      _this.detail.uen = _this.customer.uen;
      _this.detail.display_name = _this.customer.display_name;
      _this.detail.customer_remark = _this.customer.customer_remark;
      _this.detail.entity_id = _this.customer.entity_id;
      _this.detail.group_id = _this.customer.group_id;
      _this.detail.phone = _this.customer.phone;
      _this.detail.website = _this.customer.website;
      _this.detail.unit_number = _this.customer.unit_number;
      _this.detail.address_line_1 = _this.customer.address_line_1;
      _this.detail.address_line_2 = _this.customer.address_line_2;
      _this.detail.company_number = _this.customer.company_number;
      _this.detail.company_fax = _this.customer.company_fax;
      _this.detail.company_email = _this.customer.company_email;
      _this.detail.company_type = _this.customer.company_type;
      _this.detail.sales_person = _this.customer.sales_person;
      _this.detail.sales_person_id = _this.customer?.sales_person_relation?.id;
      _this.detail.sales_contact = _this.customer.sales_contact;
      _this.detail.postal_code = _this.customer.postal_code;
      _this.detail.country = _this.customer.country;
      _this.detail.security_code = _this.customer.security_code;
      _this.detail.state = _this.customer.state;
      _this.detail.city = _this.customer.city;
      _this.detail.profile_logo = _this.customer.profile_logo;
      _this.detail.funding_organisation = _this.customer.funding_organisation;
      _this.detail.special_attention = _this.customer.special_attention;
      _this.detail.contract_type = _this.customer.contract_type;
      _this.detail.contract_duration = _this.customer.contract_duration;
      _this.detail.contract_start_date = _this.customer.contract_start_date;
      _this.detail.contract_end_date = _this.customer.contract_end_date;
      _this.detail.payment_method = _this.customer.payment_method;
      _this.detail.service = _this.customer.service;
      _this.detail.actual_start_date = _this.customer.actual_start_date;
      _this.detail.payment_type = _this.customer.payment_type;
      _this.detail.dialysis_shift = _this.customer.dialysis_shift;

    },
    getLead() {
      const _this = this;
      let fullname = _this.lead.name ? _this.lead.name.split(" ") : [];
      _this.detail.first_name = fullname[0];
      _this.detail.last_name = fullname[1];
      _this.detail.company_name = _this.lead.company;
      _this.detail.uen = _this.lead.uen;
      _this.detail.display_name = _this.lead.company;
      _this.detail.phone = _this.lead.phone_number;
      _this.detail.website = _this.lead.website;
      _this.detail.postal_code = _this.lead.zip;
      _this.detail.country = _this.lead.country;
      _this.detail.state = _this.lead.state;
      _this.detail.city = _this.lead.city;
      _this.detail.unit_number = _this.lead.unit_no;
      _this.detail.address_line_1 = _this.lead.address_1;
      _this.detail.address_line_2 = _this.lead.address_2;

      _this.emailDetails[0] = new Object({
        title: "main",
        value: _this.lead.email,
        type: 1,
        id: null,
      });

      _this.contactDetails[0] = new Object({
        title: "main",
        value: _this.lead.phone_number,
        type: 2,
        id: null,
      });

      _this.updateDetails();
    },
    getProposal() {
      const _this = this;
      _this.pageLoading = true;
      _this.$store
        .dispatch(GET, {
          url: "proposals/" + _this.proposal,
        })
        .then(({ data }) => {
          let fullname = data.name ? data.name.split(" ") : [];
          _this.detail.first_name = fullname[0];
          _this.detail.last_name = fullname[1];
          _this.detail.company_name = data.company;
          _this.detail.display_name = data.company;
          _this.detail.uen = data.uen;
          _this.detail.phone = data.phone_number;
          _this.detail.website = data.website;
          _this.detail.postal_code = data.zip;
          _this.detail.country = data.country;
          _this.detail.state = data.state;
          _this.detail.city = data.city;
          _this.detail.address_line_1 = data.address;

          _this.emailDetails[0] = new Object({
            title: "main",
            value: data.email,
            type: 1,
            id: null,
          });

          _this.contactDetails[0] = new Object({
            title: "main",
            value: data.phone_number,
            type: 2,
            id: null,
          });

          _this.updateDetails();
        })
        .catch((error) => {
          _this.logError(error);
          _this.goBack();
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
  },
  mounted() {
    // console.log();
    const _this = this;
    _this.entityList = getConfig("entity");

    const firstEntity = _this.lodash.find(_this.entityList, { id: 1 });
    if (firstEntity) {
      _this.detail.entity_id = firstEntity.id;
    }

    _this.getGroupList();
    if (_this.lodash.isEmpty(_this.customer) === false) {

      _this.editDetails();
    }

    _this.proposal = _this.lodash.toSafeInteger(_this.$route.query.proposal);
    if (_this.proposal > 0) {
      _this.getProposal();
    }
    this.getOptions();
  },
  components: {
    PhoneTextField,
    TextValidateInput,
    ManageOrganisation,
    DatePicker,
    ManageService,
    TagAutoComplete,
    ManagePaymentCategory
    /* ContactPersons */
  },
  computed: {
    getProfileImage() {
      return this.lodash.isEmpty(this.detail.profile_logo) === false
        ? this.detail.profile_logo.file.url
        : null;
    },
  },
};
</script>
